import React, { useState, useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import NProgress from 'nprogress';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';

const AddBalance = () => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const { user } = useContext(AuthContext);

    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

    useEffect(() => {
        NProgress.done();
    }, []);

    const characterCount = message.length;
    const messageCount = Math.ceil(characterCount / 160);
    const totalCost = messageCount * 0.5;
    const userBalance = Number(user?.balance || 0);
    const hasInsufficientBalance = userBalance < totalCost;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!phoneNumber || !message) {
            toast.error('Telefon belgini we habary dolduryň.');
            return;
        }

        if (!/^\d{8}$/.test(phoneNumber)) {
            toast.error('Telefon belgisi 8 sandan ybarat bolmaly (meselem: 61234567).');
            return;
        }

        if (hasInsufficientBalance) {
            toast.error(`Balans ýeterlik däl. Gerek: ${totalCost.toFixed(2)} TMT`);
            return;
        }

        try {
            setLoading(true);
            NProgress.start();

            const res = await axios.post(`${API_URL}/sms/send`, {
                phoneNumber,
                message,
            });

            toast.success('SMS üstünlikli ugradyldy!');
            setPhoneNumber('');
            setMessage('');
        } catch (err) {
            const errorMsg = err.response?.data?.message || 'SMS ugratmakda näsazlyk ýüze çykdy';
            toast.error(errorMsg);
        } finally {
            setLoading(false);
            NProgress.done();
        }
    };

    return (
        <>
            <Helmet>
                <title>SMS Serwis - Balans goşmak</title>
            </Helmet>

            <div className="bg-white p-6 rounded-lg shadow-md max-w-xl mx-auto">
                <h2 className="text-xl font-semibold mb-4">Balans goşmak</h2>

                <form onSubmit={handleSubmit}>

                    {/* Telefon belgisi */}
                    <div className="mb-4">
                        <label htmlFor="phoneNumber" className="block text-sm text-gray-600 mb-1">
                            Ulanyjyny saýla:
                        </label>

                        <select name="">
                            <option>Admin</option>
                            <option>Kakabayoff</option>
                        </select>

                    </div>

                    {/* SMS habar */}
                    <div className="mb-4">
                        <label htmlFor="message" className="block text-sm text-gray-600 mb-1">
                            Mukary(TMT 0.00):
                        </label>


                        <input
                            type="option"
                            id="amount"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            disabled={loading}
                            maxLength={8}
                            className="w-full border-b-2 border-gray-300 focus:border-blue-500 outline-none py-2 px-1 text-gray-900"
                            placeholder="Meselem: 1.50"
                        />
                    </div>

                    {/* Statistikalar
          <div className="flex justify-between text-sm text-gray-500 mb-4">
            <div>Simwol: {characterCount} / SMS: {messageCount}</div>
            <div>Jemi: {totalCost.toFixed(2)} TMT</div>
          </div> */}

                    {/* Balans we düwme */}
                    <div className="flex justify-between items-center">
                        <div className="text-sm text-gray-600">
                            Balansyňyz: {userBalance.toFixed(2)} TMT
                        </div>

                        <button
                            type="submit"
                            disabled={loading || hasInsufficientBalance}
                            className={`py-2 px-4 text-sm font-medium rounded-md text-white transition 
                ${loading || hasInsufficientBalance
                                    ? 'bg-gray-400 cursor-not-allowed'
                                    : 'bg-blue-600 hover:bg-blue-700'}`}
                        >
                            {loading ? 'Ugradylýar...' : 'SMS Ugrat'}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default AddBalance;
